var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('notifications',{attrs:{"position":"bottom right","animation-type":"css"}}),_c('sidebar'),_c('app-bar'),_c('v-main',[_c('router-view',{key:_vm.activeTenant}),_c('v-spacer'),_c('ptsi-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }